import React from 'react'
import AjaxButton from "../../../form/ajax_button";
import classNames from "classnames";
import {setLeadGenerationAccountOrganizationIds, updateTagOwnerConnections} from "../../exhibition_actions";
import {useDispatch, useSelector} from "react-redux";

export default function LeadGenerationPreview({data, onModalClose, imageMap, ...props}) {
  // let html = ""
  // if (data.leadGenerationData) {
  //   html = data.leadGenerationData.html
  // }

  const dispatch = useDispatch()
  //const company = imageMap.accountOrganization?.title
  let account_organization_id = props.account_organization_id || imageMap?.account_organization_id

  const accountOrganization = useSelector((state) => state.accountOrganizations?.find((accountOrganization) => accountOrganization.id === account_organization_id))
  const previewAccountOrganization = useSelector((state) => state.accountOrganization)
  const leadGenerationUrl = useSelector(state => state.leadGenerationUrl)
  const leadGenerationAccountOrganizationIds = useSelector(state => state.leadGenerationAccountOrganizationIds)
  const html = (accountOrganization || previewAccountOrganization)?.lead_generation_text
  const isBoothEditor = useSelector(state => state.isBoothEditor)


  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div dangerouslySetInnerHTML={{__html: html}}/>
          {/*<h4>Privacy policy</h4>*/}
          {/*<hr/>*/}
          {/*I hereby agree that the company responsible for the virtual exhibition booth stand will receive my following*/}
          {/*registration data and may contact me afterwards.*/}

          {/*<hr/>*/}
          {/*<br/>*/}
          {/*<strong>You are about to share these contact data</strong>*/}
          {/*<ul>*/}
          {/*  <li>full name</li>*/}
          {/*  <li>address (institute/company, department, address)</li>*/}
          {/*  <li>email address</li>*/}
          {/*</ul>*/}
          {/*<hr/>*/}

          {/*<p>*/}
          {/*  By giving your consent, you agree that your personal data will be processed by {company}*/}
          {/*  within the EEA. {company} processes your personal data with the corresponding consent*/}
          {/*  for the purpose of providing marketing and information material relating to the field of*/}
          {/*  digestive health as well as information on scientific events from the respective*/}
          {/*  sponsor/exhibitor in accordance with the applicable laws and regulations.*/}
          {/*</p>*/}
          {/*<hr/>*/}

          {/*<p>*/}
          {/*  {company} determines the retention period of your personal data based on the following*/}
          {/*  criteria: (a) the purpose for which we use your personal information: we keep the information*/}
          {/*  for that purpose for as long as necessary; and (b) legal obligations: different laws and*/}
          {/*  regulations impose minimum retention periods that we are obliged to comply with.*/}
          {/*</p>*/}

          {/*<hr/>*/}
          {/*<p>*/}
          {/*  In accordance with the General Data Protection Regulation, you have the right to access,*/}
          {/*  rectify, data portability or delete your personal data and you have the right to withdraw*/}
          {/*  your consent at any time by sending a corresponding email to*/}
          {/*  <a href="mailto:privacy.nl@sanofi.com">privacy.nl@sanofi.com</a>,*/}
          {/*  address: Paasheuvelweg 25, 1105 BP Amsterdam, tel: 020- 2454000.*/}
          {/*  The rightfulness of this data processing is based on your consent.*/}
          {/*  {company} will process your data until you withdraw your consent. You are not obliged to give this*/}
          {/*  consent. If you are not giving your consent, you will not have any further disadvantages.*/}
          {/*  For more information, check our privacy policy on*/}
          {/*  <a href={"https://www.sanofienprivacy.nl"}>www.sanofienprivacy.nl.</a>*/}
          {/*</p>*/}
          {/*<div dangerouslySetInnerHTML={{__html: html}}/>*/}
        </div>
        <div className="modal-footer">
          {isBoothEditor && <div className={"btn-ueg"}>Not Available in editor</div>}
          {(leadGenerationAccountOrganizationIds && leadGenerationAccountOrganizationIds.some((id) => account_organization_id == id)) ?
            <p>ALREADY ACCEPTED</p>
            : (!isBoothEditor && <AjaxButton
              method={"post"}
              label={"ACCEPT"}
              labelSending={"ACCEPTING..."}
              icon={"fa-check"}
              className={classNames("btn-ueg")}
              url={leadGenerationUrl}
              data={{
                account_organization_id: account_organization_id
              }}
              onSuccess={(data) => {
                if (data.data.status === "OK") {
                  dispatch(setLeadGenerationAccountOrganizationIds(data.data.leadGenerationAccountOrganizationIds))
                } else {
                  alert(data.data.message || "Error while generating lead.")
                }
              }}
              onError={(error) => {
                console.log(error)
                alert("Error while generating lead.", error)
              }}
            />)}
        </div>
      </div>
    </div>
  </div>;
}
